import { useAbility } from '@/hooks/ability';
import api from '@/services/api/api';
import { useQuery } from '@tanstack/react-query';

export type GetUserNotificationOperationsDTO = {
  id: string;
  name: string;
  is_active: boolean;
};

type Params = {
  userId: string;
  messageId: string;
  enabled?: boolean;
};

type Options = {
  onSuccess: (data: GetUserNotificationOperationsDTO[]) => void;
};

export const useGetUserNotificationOperationsQuery = (
  { userId, messageId, enabled = true }: Params,
  options?: Options,
) => {
  const ability = useAbility();
  const hasPermission = ability.can('admin.message.index', '');

  return useQuery({
    queryKey: [`admin/user/${userId}/message-team-credit-status`],
    queryFn: async () => {
      const response = await api.get(`admin/user/${userId}/message-team-credit-status/${messageId}`);

      options?.onSuccess?.(response.data ?? []);
      return response.data;
    },
    staleTime: 1000,
    enabled: !!userId && hasPermission && enabled,
  });
};
